import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/seanrioux/products/open-source-okr/code/react-okr-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Objective from "../components/Objective";
import Progress from "../components/Progress";
import Result from "../components/Result";
import Current from "../components/Current";
import Score from "../components/Score";
import Goal from "../components/Goal";
import Due from "../components/Due";
import Okr from "../components/Okr";
import Row from "../components/Row";
import { Playground, Props } from "docz";
import { dateOptions, metrics, results, grades } from "../data/example.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "react-okr-ui"
    }}>{`React OKR UI`}</h1>
    <p>{`An open source user interface for building OKR centric applications with React.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <Okr metrics={metrics} grades={grades} mdxType="Okr">
	<Objective mdxType="Objective">
		<Row type="flex" mdxType="Row">
			<Goal label="Objective" text="Carve out a niche" mdxType="Goal" />
			<Due label="Due date" date="2022/01/01" options={{
            year: "numeric",
            month: "short",
            day: "numeric"
          }} mdxType="Due" />
		</Row>
		<Progress label="progress" value={0.75} mdxType="Progress" />
		<Result mdxType="Result">
			<Row type="flex" mdxType="Row">
				<Goal label="Key Result" direction="decrease" metricId="1" start={20} end={50} mdxType="Goal" />
				<Row type="flex" mdxType="Row">
					<Current className="okr-mr-1" label="Current" metricId="1" value={30} mdxType="Current" />
					<Score className="okr-ml-1" direction="decrease" start={20} end={50} current={30} circle mdxType="Score" />
				</Row>
			</Row>
		</Result>
		<Result mdxType="Result">
			<Row type="flex" mdxType="Row">
				<Goal label="Key Result" direction="increase" metricId="2" start={110} end={190} mdxType="Goal" />
				<Row type="flex" mdxType="Row">
					<Current className="okr-mr-1" label="Current" metricId="2" current={175} mdxType="Current" />
					<Score className="okr-ml-1" direction="increase" start={110} end={190} current={175} circle mdxType="Score" />
				</Row>
			</Row>
		</Result>
		<Result mdxType="Result">
			<Row type="flex" mdxType="Row">
				<Goal label="Key Result" direction="attain" metricId="3" start={1000} end={10000} mdxType="Goal" />
				<Row type="flex" mdxType="Row">
					<Current className="okr-mr-1" label="Current" metricId="3" value={30} mdxType="Current" />
					<Score className="okr-ml-1" direction="attain" start={1000} end={10000} current={7000} circle mdxType="Score" />
				</Row>
			</Row>
		</Result>
	</Objective>
    </Okr>
    <h2 {...{
      "id": "gettin-started"
    }}>{`Gettin Started`}</h2>
    <p>{`Getting started is easy. Simply install the package via npm:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install react-okr-ui
`}</code></pre>
    <p>{`Once installed, import the components you need into your React app:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Okr, Objective, Result, Goal } from "react-okr-ui";
`}</code></pre>
    <p>{`To view all the component in action, check out the playground `}<a parentName="p" {...{
        "href": "%22/components#example%22"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      